import { LAYOUT_CONFIG } from '@/lib/config/layout'
import { stringToSlug } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

export const FooterMenu = () => {
  const t = useTranslations('footer')

  return (
    <div className='mb-8 mt-7 border-t border-t-light/30 pt-7'>
      {/* Menu chính sách & liên kết */}
      <nav
        aria-label='Chính sách & Liên kết'
        className='flex items-start gap-32.5 gap-y-16 max-xl:flex-wrap'
      >
        <div className='grid flex-1 grid-cols-4 justify-between'>
          {LAYOUT_CONFIG.FOOTER.menu.map((item, idx) => (
            <div key={idx} className='space-y-8'>
              {item.map((menu) => (
                <ul
                  key={menu.title}
                  className='h-fit'
                  aria-labelledby={`menu-${idx}`}
                >
                  <li className='mb-1'>
                    <h2
                      id={`menu-${idx}`}
                      className='font-sans text-sm font-medium uppercase leading-7 text-light'
                    >
                      {t(menu.title)}
                    </h2>
                  </li>
                  {menu.items.map((item) => {
                    const isExternal = item.url.startsWith('http')
                    return (
                      <li key={item.url} className='mb-3 last-of-type:mb-0'>
                        <Link
                          href={item.url}
                          className='text-body-3 block text-neutral-300 hover:text-primary'
                          target={isExternal ? '_blank' : undefined}
                          rel={isExternal ? 'noopener noreferrer' : undefined}
                          data-tracking-level-3={stringToSlug(item.label)}
                        >
                          {t(item.label)}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              ))}
            </div>
          ))}
        </div>

        {/* Địa chỉ liên hệ */}
        <address className='w-1/4'>
          <h2 className='font-sans text-sm font-medium uppercase leading-7 text-light'>
            {t('menu.contact.title')}
          </h2>
          <ul className='flex flex-col gap-y-6 not-italic'>
            {LAYOUT_CONFIG.FOOTER.addresses.map((address, index) => (
              <li key={index} className='text-body-3 text-neutral-300'>
                <span className='underline'>{t(address.title)}:</span>{' '}
                {t(address.address)}
              </li>
            ))}
          </ul>
        </address>
      </nav>
    </div>
  )
}
